<template>
  <div>
    <loading v-show="load"/>
    <div v-show="!load" class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0 font-weight-bold">Regras de impressão</h6>
          <button class="btn btn-secondary btn-sm" @click="cadastrarRegra">
            <i class="fa fa-plus mr-1"></i> Cadastrar
          </button>
        </div>
        <draggable
          v-if="regras.length"
          v-model="regras"
          :disabled="load || salvandoStatus !== null"
          handle=".drag-regra"
          @change="salvarOrdenacao"
        >
          <div v-for="(regra, i) in regras" :key="regra.id_impressao_regra || i">
            <div class="border-top pt-2 mt-2">
              <div class="row align-items-center">
                <div class="col-sm-6 col-lg-6 pointer d-flex align-items-center" @click="editarRegra(regra)">
                  <span class="drag-regra mr-2" title="Arraste para ordenar" @click.stop>
                    <i class="fa fa-bars"></i>
                  </span>
                  <div>
                    {{ regra.nome_regra }}
                    <div v-if="regra.impressora_descricao" class="small text-muted">{{ regra.impressora_descricao }}</div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-6 text-sm-right">
                  <div class="py-1 text-nowrap">
                    <button :class="Number(regra.fg_ativo) === 1 ? 'btn-secondary' : 'btn-light'" :disabled="salvandoStatus !== null" class="btn btn-sm mr-1" @click="toggleRegra(regra, 1)">Ativado</button>
                    <button :class="Number(regra.fg_ativo) === 2 ? 'btn-secondary' : 'btn-light'" :disabled="salvandoStatus !== null" class="btn btn-sm mr-3" @click="toggleRegra(regra, 2)">Desativado</button>
                    <button class="btn btn-primary btn-sm mr-1" style="width: 34px" @click="editarRegra(regra)">
                      <i class="fa fa-pencil-alt"></i>
                    </button>
                    <button class="btn btn-dark btn-sm" style="width: 34px" @click="deletarRegra(regra)">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </draggable>
        <div v-else class="py-5 text-center">
          <h5 class="mb-1">Cadastrar Regras</h5>
          <p class="mx-auto mb-4" style="max-width: 600px">
            Cadastre as regras que vão decidir como os pedidos entram no novo fluxo de impressão.
          </p>
          <button class="btn btn-secondary" @click="cadastrarRegra">Cadastrar</button>
        </div>
      </div>
    </div>

    <modal :opened="modalRegra" no-pad="true">
      <regra-impressao-nova
        :impressoras="impressoras"
        @fechar="modalRegra = false"
        @salvar="buscarRegras"
      />
    </modal>
  </div>
</template>

<script>
import Loading from "../../gestor/loading";
import Modal from "../../gestor/ModalGestor";
import RegraImpressaoNova from "./RegraImpressaoNova";
import Draggable from "vuedraggable";

export default {
  name: "ConfigRegrasImpressaoNova",
  components: {
    Draggable,
    Loading,
    Modal,
    RegraImpressaoNova
  },

  props: {
    impressoras: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      load: false,
      regras: [],
      salvandoStatus: null,
      modalRegra: false
    };
  },

  methods: {
    toggleRegra(regra, status) {
      if (this.salvandoStatus !== null || Number(regra.fg_ativo) === status) {
        return;
      }

      const statusAnterior = regra.fg_ativo;
      regra.fg_ativo = status;
      this.salvandoStatus = regra.id_impressao_regra;
      this.$http.post('v2/impressao/regra', {
        id_impressao_regra: regra.id_impressao_regra,
        fg_ativo: status
      }).then(response => {
        this.salvandoStatus = null;

        if (response.data?.success) {
          return;
        }

        regra.fg_ativo = statusAnterior;
        this.$swal("Erro ao alterar o status da regra.");
      }, res => {
        regra.fg_ativo = statusAnterior;
        this.salvandoStatus = null;
        this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao alterar o status da regra');
      });
    },

    salvarOrdenacao({ moved }) {
      if (!moved) {
        return;
      }

      const regrasAnteriores = this.regras.slice();
      regrasAnteriores.splice(moved.newIndex, 1);
      regrasAnteriores.splice(moved.oldIndex, 0, moved.element);
      this.load = true;

      this.$http.post('v2/impressao/regras/ordenacao', {
        regras: this.regras.map(regra => Number(regra.id_impressao_regra))
      }).then(response => {
        this.load = false;

        if (response.data?.success) {
          this.regras.forEach((regra, indice) => {
            regra.ordem_execucao = indice + 1;
          });
          return;
        }

        this.regras = regrasAnteriores;
        this.$swal("Erro ao salvar a ordenação das regras.");

      }, res => {
        this.load = false;
        this.regras = regrasAnteriores;
        this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao salvar a ordenação das regras');
      });
    },

    buscarRegras() {
      this.load = true;
      this.modalRegra = false;

      this.$http.get('v2/impressao/regras')
        .then(response => {
          const body = response.data || [];
          const regras = Array.isArray(body) ? body : (body.data || []);
          this.regras = Array.isArray(regras[0]) ? regras[0] : regras;
          this.load = false;

        }, res => {
          this.load = false;
          this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao buscar as regras');
        });
    },

    editarRegra(regra) {
      this.$emit('openModal', regra);
      this.modalRegra = true;
    },

    deletarRegra(regra) {
      this.$swal({
        text: "Deseja deletar esta regra?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.load = true;
          this.$http.post('v2/impressao/regra', {
            id_impressao_regra: regra.id_impressao_regra,
            delete: 1
          })
            .then(res => {
              this.load = false;

              if (res.data?.success) {
                this.$swal("Regra deletada com sucesso!");
                this.buscarRegras();
                return;
              }

              this.$swal("Erro ao deletar a regra.");

            }, res => {
              this.load = false;
              this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao deletar a regra');
            });
        }
      });
    },

    cadastrarRegra() {
      this.editarRegra({
        nome_regra: '',
        id_impressora: null,
        layout_tipo: 2,
        pedido_delivery: 1,
        pedido_retirada: 1,
        pedido_consumo: 1,
        tipo_impressao: 1,
        qtd_copias: 1,
        categorias: []
      });
    }
  },

  created() {
    this.buscarRegras();
  }
}
</script>

<style scoped>
.drag-regra {
  cursor: grab;
}
</style>
